'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import { browserHistory } from 'react-router';

// import { processQuery } from 'helpers/lib';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactRedux = require('react-redux');

var _address = require('redux/modules/address');

var addressActions = _interopRequireWildcard(_address);

var _filter = require('redux/modules/filter');

var filterActions = _interopRequireWildcard(_filter);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _analytics = require('redux/modules/analytics');

var analyticsActions = _interopRequireWildcard(_analytics);

var _notification = require('redux/modules/notification');

var notificationActions = _interopRequireWildcard(_notification);

var _reduxForm = require('redux-form');

var _reactRouterRedux = require('react-router-redux');

var _support = require('helpers/support');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _lodash = require('lodash');

var _arrowBack = require('assets/img/common/arrow-back.png');

var _arrowBack2 = _interopRequireDefault(_arrowBack);

var _readAll = require('assets/img/notification/readAll.png');

var _readAll2 = _interopRequireDefault(_readAll);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WAIT_INTERVAL = 1000;
var ENTER_KEY = 13;
// Support whole-word or regex matching (keys starting with `^` are recognized
// as regex)
// NOTED:
// Những route có dữ liệu động, thay đổi thì không thể fix cố định. Phải dùng props change.
// Dữ liệu header được tạo trong setup reducer, tùy thuộc vào thay đổi của từng trang mà header thay đổi khác nhau.
var HeaderMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    provinces: state.address.provinces,
    province: state.address.province,
    categories: state.setup.categories,
    categoriesFilter: state.setup.categoriesFilter,
    query: state.filter.query,
    districts: state.address.districts,
    district_parent: state.address.district_parent,
    districts_loading: state.address.districts_loading,
    addressFilter: state.address.addressFilter,
    subCatFilter: state.setup.subCatFilter,
    header: state.setup.header,
    filterActive: state.filter.filterActive,
    coords: state.user.coords,
    backBookingSuccess: state.booking.backBookingSuccess,
    bookingSubmit: state.booking.submit,
    configHeader: state.setup.configHeader,
    submit: state.booking.submit
  };
}, (0, _extends3.default)({}, addressActions, filterActions, setupActions, notificationActions, {
  initializeWithKey: _reduxForm.initializeWithKey,
  push: _reactRouterRedux.push,
  changeBooking: bookingActions.changeBooking,
  manualTrack: analyticsActions.manualTrack

})), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(HeaderMobile, _Component);

  function HeaderMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, HeaderMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HeaderMobile.__proto__ || (0, _getPrototypeOf2.default)(HeaderMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      pathname: _this.props.pathname || '',
      query: _this.props.query,
      focus: false
    }, _this.onClickGoBack = function () {
      var _this$props = _this.props,
          backBookingSuccess = _this$props.backBookingSuccess,
          history = _this$props.history,
          changeBooking = _this$props.changeBooking,
          configHeader = _this$props.configHeader,
          bookingSubmit = _this$props.bookingSubmit,
          manualTrack = _this$props.manualTrack;

      var numberBack = -4;
      if (backBookingSuccess) {
        history.go(numberBack);
        changeBooking('backBookingSuccess', false);
      } else {
        var tracking = _this.trackingData();
        if (manualTrack) manualTrack((0, _extends3.default)({}, tracking, { button: 'Back' }));
        if (configHeader.page === 'BookingOne') {
          _reactGa2.default.event({
            category: 'Booking',
            action: 'Back at Step 1',
            label: '' + bookingSubmit.shop.name
          });
        }
        if (configHeader.page === 'BookingTwo') {
          _reactGa2.default.event({
            category: 'Booking',
            action: 'Back at Step 2',
            label: '' + bookingSubmit.shop.name
          });
        }
        if (configHeader.page === 'BookingThree') {
          _reactGa2.default.event({
            category: 'Booking',
            action: 'Back at Step Submit',
            label: '' + bookingSubmit.shop.name
          });
        }

        history.goBack();
      }
    }, _this.trackingData = function () {
      var _this$props$submit = _this.props.submit,
          shop = _this$props$submit.shop,
          code = _this$props$submit.code,
          bookingServices = _this$props$submit.bookingServices,
          userInfo = _this$props$submit.userInfo;

      var track = (0, _extends3.default)({
        code: code,
        shopId: shop ? shop.id : ''
      }, userInfo);
      if (bookingServices && bookingServices.length) {
        track.serviceId = bookingServices.reduce(function (result, bService) {
          return bService.number > 0 ? [].concat((0, _toConsumableArray3.default)(result), [bService.service]) : result;
        }, []);
      }
      return track;
    }, _this.onClickCancel = function () {
      var _this$props2 = _this.props,
          history = _this$props2.history,
          configHeader = _this$props2.configHeader,
          bookingSubmit = _this$props2.bookingSubmit,
          manualTrack = _this$props2.manualTrack;

      var accept = confirm('Bạn chắc chắn muốn huỷ chứ?');
      var tracking = _this.trackingData();
      if (manualTrack) manualTrack((0, _extends3.default)({}, tracking, { button: 'Exit' }));
      if (accept) {
        if (configHeader.page === 'BookingOne' && configHeader.page.indexOf('Booking') === 0) {
          _reactGa2.default.event({
            category: 'Booking',
            action: 'Cancel at Step 1',
            label: '' + bookingSubmit.shop.name
          });
        }
        if (configHeader.page === 'BookingTwo' && configHeader.page.indexOf('Booking') === 0) {
          _reactGa2.default.event({
            category: 'Booking',
            action: 'Cancel at Step 2',
            label: '' + bookingSubmit.shop.name
          });
        }
        if (configHeader.page === 'BookingThree' && configHeader.page.indexOf('Booking') === 0) {
          _reactGa2.default.event({
            category: 'Booking',
            action: 'Cancel at Step Submit',
            label: '' + bookingSubmit.shop.name
          });
        }

        history.go(-configHeader.screen);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(HeaderMobile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (String(this.props.province) !== String(this.props.district_parent) && !this.props.districts_loading) {
        this.props.loadDistrict(this.props.province);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var flag = false;
      if (nextProps.query !== this.state.query) {
        this.setState({ query: nextProps.query });
      }
      if (nextProps.province !== this.props.province) {
        this.props.loadDistrict(nextProps.province);
        flag = true;
      }
      if (flag) {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.getResult.bind(this), WAIT_INTERVAL);
      }
    }
  }, {
    key: 'checkSortNearby',

    // ======================
    // PHẦN CHO TRANG TÌM KIẾM
    // ======================
    value: function checkSortNearby(filterActive) {
      var filter = (0, _extends3.default)({}, filterActive);
      var coords = this.props.coords;

      if (coords && coords.latitude && filter.sort && filter.sort.length && filter.sort[0] === 'nearby') {
        filter.lat = [coords.latitude];
        filter.lng = [coords.longitude];
      }
      return filter;
    }
  }, {
    key: 'getResult',
    value: function getResult() {
      var filterActive = (0, _extends3.default)({}, this.props.filterActive);
      if (filterActive.province && filterActive.province.length && filterActive.province[0] !== this.props.province) {
        filterActive.province = [this.props.province];
        filterActive.district = [];
      }
      this.props.changeFilter(filterActive);
      filterActive = this.checkSortNearby.call(this, filterActive);
      this.props.getShopSearch(filterActive);
      var catCode = filterActive.category && filterActive.category.length ? filterActive.category[0] : '';
      this.props.history.push((0, _extends3.default)({}, this.props.location, {
        pathname: _support.syncData.getPathByCat(catCode),
        query: (0, _support.parseQuery)(filterActive)
      }));
    }
  }, {
    key: 'triggerChange',
    value: function triggerChange() {
      var filterActive = (0, _extends3.default)({}, this.props.filterActive);
      var query = this.state.query;

      this.props.changeQuery(query);
      if (query) {
        filterActive.query = [];
      }
      filterActive.query = [query];
      this.props.changeFilter(filterActive);
      filterActive = this.checkSortNearby.call(this, filterActive);
      this.props.getShopSearch(filterActive);
      var catCode = filterActive.category && filterActive.category.length ? filterActive.category[0] : '';
      this.props.history.push((0, _extends3.default)({}, this.props.location, {
        pathname: _support.syncData.getPathByCat(catCode),
        query: (0, _support.parseQuery)(filterActive)
      }));
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(event) {
      clearTimeout(this.timer);
      this.setState({ query: event.target.value });
      this.timer = setTimeout(this.triggerChange.bind(this), WAIT_INTERVAL);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      if (event.keyCode === ENTER_KEY) {
        event.preventDefault();
        clearTimeout(this.timer);
        this.triggerChange.call(this);
      }
    }
  }, {
    key: 'handleChangeProvince',
    value: function handleChangeProvince(selectedOption) {
      if (selectedOption && selectedOption.value) {
        if (selectedOption.value !== this.props.province) {
          this.props.changeProvince(selectedOption.value);
        }
      } else {
        this.props.changeProvince('79');
      }
      // this.props.onBlur();
      this.selectProvince.input.blur();
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      this.setState({ query: '' });
      this.timer = setTimeout(this.triggerChange.bind(this), WAIT_INTERVAL);
      this.inputFocus.focus();
    }
  }, {
    key: 'readAll',
    value: function readAll() {
      this.props.readAll();
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.setState({ focus: true });
      this.props.onFocus();
    }
  }, {
    key: 'backHomepage',
    value: function backHomepage() {
      this.props.history.push('/');
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      this.setState({ focus: false });
      this.props.onBlur();
      document.activeElement.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./HeaderMobile.scss');
      var _state = this.state,
          focus = _state.focus,
          query = _state.query;
      var _props = this.props,
          className = _props.className,
          provinces = _props.provinces,
          province = _props.province,
          configHeader = _props.configHeader;

      var options = [];
      if (provinces && provinces.length) {
        for (var index = 0; index < provinces.length; index++) {
          if (provinces[index].code === '01' || provinces[index].code === '79') {
            options = (0, _lodash.concat)([{
              value: provinces[index].code,
              label: provinces[index].code === '79' ? 'Tp.HCM' : provinces[index].name
            }], options);
          } else {
            options.push({
              value: provinces[index].code,
              label: provinces[index].name
            });
          }
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.mobileHeader + ' ' + className },
        configHeader && configHeader.search && focus && _react2.default.createElement('div', {
          className: styles.bgCover,
          onClick: this.onBlur.bind(this),
          onTouchMove: this.onBlur.bind(this)
        }),
        configHeader && configHeader.back && _react2.default.createElement(
          'div',
          {
            className: styles.arrowBack,
            onClick: function onClick() {
              return _this2.onClickGoBack();
            }
          },
          _react2.default.createElement('img', { src: _arrowBack2.default })
        ),
        configHeader && configHeader.logo && _react2.default.createElement(
          'div',
          {
            div: true,
            className: styles.logo + ' ' + (configHeader.logoCenter ? styles.logoCenter : ''),
            onClick: function onClick() {
              return _this2.backHomepage();
            }
          },
          _react2.default.createElement('div', { className: styles.logoHeader })
        ),
        configHeader && configHeader.title && _react2.default.createElement(
          'div',
          { className: styles.title },
          configHeader.title
        ),
        configHeader && configHeader.cancel && _react2.default.createElement(
          'div',
          { className: styles.cancelContainer, onClick: this.onClickCancel },
          _react2.default.createElement(
            'p',
            { className: styles.cancel },
            'Tho\xE1t'
          )
        ),
        configHeader && configHeader.readAll && _react2.default.createElement(
          'div',
          { className: styles.readAll, onClick: function onClick() {
              return _this2.readAll();
            } },
          _react2.default.createElement('img', { src: _readAll2.default, className: styles.readAllIcon })
        ),
        configHeader && configHeader.search && _react2.default.createElement(
          'div',
          { className: styles.searchBox },
          _react2.default.createElement(
            'div',
            { className: styles.searchInput },
            _react2.default.createElement(
              'div',
              {
                className: styles.searchGroup + ' ' + this.props.above,
                id: 'search-mobile-header',
                onBlurCapture: this.onBlur.bind(this)
              },
              _react2.default.createElement(
                'div',
                { className: styles.searchValueBox },
                _react2.default.createElement('input', {
                  ref: function ref(e) {
                    _this2.inputFocus = e;
                  },
                  className: styles.searchValue,
                  type: 'search',
                  name: 'search',
                  placeholder: 'T\xECm ki\u1EBFm...',
                  onChange: this.handleSearch.bind(this),
                  onKeyDown: this.handleKeyDown.bind(this),
                  value: query
                }),
                _react2.default.createElement('span', {
                  className: styles.searchClear + ' ' + (query === '' ? 'hide' : ''),
                  onClick: this.clearSearch.bind(this)
                })
              ),
              _react2.default.createElement(_reactSelect2.default, {
                ref: function ref(e) {
                  _this2.selectProvince = e;
                },
                name: 'province'
                // onFocus={this.props.onFocus}
                , placeholder: 'T\u1EC9nh Th\xE0nh',
                className: styles.searchProvince,
                value: province,
                onChange: this.handleChangeProvince.bind(this),
                options: options,
                multi: false,
                searchable: false
              })
            )
          )
        )
      );
    }
  }]);
  return HeaderMobile;
}(_react.Component), _class2.propTypes = {
  text: _react.PropTypes.string,
  className: _react.PropTypes.string,
  pathname: _react.PropTypes.string,
  query: _react.PropTypes.string,
  province: _react.PropTypes.string,
  district_parent: _react.PropTypes.string,
  above: _react.PropTypes.string,
  districts_loading: _react.PropTypes.bool,
  backBookingSuccess: _react.PropTypes.bool,
  bookingSubmit: _react.PropTypes.object,
  provinces: _react.PropTypes.array,
  addressFilter: _react.PropTypes.array,
  header: _react.PropTypes.object,
  subCatFilter: _react.PropTypes.object,
  history: _react.PropTypes.object,
  location: _react.PropTypes.object,
  categoriesFilter: _react.PropTypes.object,
  filterActive: _react.PropTypes.object,
  coords: _react.PropTypes.object,
  configHeader: _react.PropTypes.object,
  submit: _react.PropTypes.object,
  // @action
  changeQuery: _react.PropTypes.func.isRequired,
  getShopSearch: _react.PropTypes.func.isRequired,
  changeFilter: _react.PropTypes.func.isRequired,
  changeProvince: _react.PropTypes.func.isRequired,
  loadDistrict: _react.PropTypes.func.isRequired,
  onBlur: _react.PropTypes.func,
  onFocus: _react.PropTypes.func,
  changeBooking: _react.PropTypes.func,
  readAll: _react.PropTypes.func,
  manualTrack: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = HeaderMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/HeaderMobile.js
// module id = 1577
// module chunks = 0